module.exports = __webpack_public_path__ + "img/red-lights-car.99ca75e4.jpg";